export const DEMO_SEARCH_PAGE_SIZE = 15;
export const DEMO_MAX_ITEMS_FILTER_COUNT = 100;
